module.exports = __webpack_public_path__ + "static/media/menu-btn.97a542d1.svg";